import React, { useState, useRef } from "react";
import './comp_file_upload.css';
const Comp_File_Upload = ({ label = "Choose File", className = "", uniquefileName="" }) => {
  const [fileName, setFileName] = useState("No file chosen");
  const inputRef = useRef(null);

  const handleChange = (e) => {
    setFileName(
      e.target.files && e.target.files.length
        ? e.target.files[0].name
        : "No file chosen"
    );
  };

  return (
    <div className={`file-upload ${className}`}>
      <input
        name={uniquefileName}
        id={uniquefileName}
        type="file"
        ref={inputRef}
        className="file-input"
        onChange={handleChange}
      />

      <button
        type="button"
        className="file-btn"
        onClick={() => inputRef.current.click()}
      >
        📁 {label}
      </button>

      <span className="file-name">{fileName}</span>
    </div>
  );
};

export default Comp_File_Upload;